import React, { useEffect, useState, useMemo, useRef } from "react";
import { formatNumberWithCommas, formatDate } from '../../../common/utility'
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    InputGroup
} from "reactstrap";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TableContainerV1 from "components/Common/TableContainerV1";
import { getOrderRequestReport } from "../../../helpers/UAM/report.helper"
import * as XLSX from 'xlsx';

const OrderRequestReport = ({ dealer = false }) => {

    //meta title
    document.title = "Order Request Reports | DMS";

    const [orderReportData, setOrderReportData] = useState([])

    const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("orderCode");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [filters, setFilters] = useState(null);
    const [sortingOptions, setSortingOptions] = useState({
        column: "",
        isAsc: false,
        optionalColumn: [],
    });
    const flatpickrRef = useRef(null);

    const user = JSON.parse(localStorage.getItem("user"));
    // Customber Column
    const dealerUserColumns = useMemo(
        () => [

            {
                Header: 'Order Request No',
                accessor: 'orderCode',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Total Amount',
                accessor: 'totalAmount',
                filterable: true,
                alignRight: true,
                Cell: (cellProps) => (
                    <div style={{ textAlign: 'right' }}>
                        {cellProps.value ? formatNumberWithCommas(cellProps.value) : ""}
                    </div>

                ),
            },
            {
                Header: 'No. of Products',
                accessor: 'productCount',
                Cell: (cellProps) => (
                    <div style={{ textAlign: 'center' }}>
                        {cellProps.value ? cellProps.value : ""}
                    </div>
                )
            },
            {
                Header: 'Creation Date',
                accessor: 'createdAt',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatDate(cellProps.value) : '';
                }
            },
            {
                Header: 'PO Number',
                accessor: 'poNumber',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'PO Date',
                accessor: 'poDate',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatDate(cellProps.value) : "";
                }
            },
            {
                Header: 'Status',
                accessor: 'orderStatus',
                filterable: true,
                Cell: (cellProps) => (
                    <span className="text-capitalize">
                        {cellProps.value ? cellProps.value : ""}
                    </span>
                )
            },

        ],
        []
    );

    const nonDealerUserColumns = useMemo(
        () => [

            {
                Header: 'Order Request No',
                accessor: 'orderCode',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Total Amount',
                accessor: 'totalAmount',
                filterable: true,
                alignRight: true,
                Cell: (cellProps) => (
                    <div style={{ textAlign: 'right' }}>
                        {cellProps.value ? formatNumberWithCommas(cellProps.value) : ""}
                    </div>

                ),
            },
            {
                Header: 'No. of Products',
                accessor: 'productCount',
                Cell: (cellProps) => (
                    <div style={{ textAlign: 'center' }}>
                        {cellProps.value ? cellProps.value : ""}
                    </div>
                )
            },
            {
                Header: 'Creation Date',
                accessor: 'createdAt',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatDate(cellProps.value) : '';
                }
            },
            {
                Header: 'PO Number',
                accessor: 'poNumber',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'PO Date',
                accessor: 'poDate',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? formatDate(cellProps.value) : "";
                }
            },
            {
                Header: 'Dealer Name',
                accessor: 'entityName',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value ? cellProps.value : "";
                }
            },
            {
                Header: 'Status',
                accessor: 'orderStatus',
                filterable: true,
                Cell: (cellProps) => (
                    <span className="text-capitalize">
                        {cellProps.value ? cellProps.value : ""}
                    </span>
                )
            },

        ],
        []
    );

    const columns = user.entityType === 'dealer' ? dealerUserColumns : nonDealerUserColumns

    const searchHelperText = user.entityType === 'dealer'
        ? "Search by Order Request No, Status"
        : "Search by Order Request No, Status, Dealer Name"

    useEffect(() => {
        fetchOrderReport({})
    }, [])

    const fetchOrderReport = (data) => {
        getOrderRequestReport(data)
            .then((response) => {
                if (response.status && response.code == 200) {
                    setOrderReportData(response.data.data);
                    const { totalItems, totalPages, currentPage } = response.data
                    setPagination({
                        pageIndex: currentPage,
                        pageCount: totalPages,
                        totalRecords: totalItems,
                    })
                } else {
                    setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
                    setOrderReportData([])
                }
            })
            .catch((err) => { console.log(err) })
    }

    const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus, filterType = filters) => {
        setPageSize(pageSize);
        setCurrentPage(page)
        fetchOrderReport({ page, limit: pageSize, searchKey, columnName, sortingOrder, filterType })
    };

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
    };

    const handleSearchFilter = (value, pageSize) => {
        const newValue = value !== undefined ? value : "";
        setSearchValue(newValue);
        handlePageChange(1, pageSize, newValue);
    };

    const handleClearSearch = () => {
        setSearchValue("");
        setFilters(null)
        flatpickrRef.current.flatpickr.clear();
        setSearchValue("");
        handlePageChange(1, pageSize, "", 'orderCode', 'desc', null);
    };

    const handleDateFilter = () => {
        handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filters)
    }

    const handleDateChange = (selectedDates) => {
        if (selectedDates.length === 2) {
            setFilters({
                startDate: selectedDates[0],
                endDate: selectedDates[1],
            })
        }
    };

    const downloadExcel = () => {
        let dataWithModifiedCol;
        if (user.entityType === 'dealer') {
            dataWithModifiedCol = orderReportData.map(report => {
                let newReport = {
                    "Order Request No": report.orderCode,
                    "Total Amount": report.totalAmount,
                    "No. of Products": report.productCount,
                    "Creation Date": report.createdAt,
                    "PO Number": report.poNumber,
                    "PO Date": report.poDate,
                    "Status": report.orderStatus,
                }
                return newReport
            })

        } else {
            dataWithModifiedCol = orderReportData.map(report => {
                let newReport = {
                    "Order Request No": report.orderCode,
                    "Total Amount": report.totalAmount,
                    "No. of Products": report.productCount,
                    "Creation Date": report.createdAt,
                    "PO Number": report.poNumber,
                    "PO Date": report.poDate,
                    "Dealer Name": report.entityName,
                    "Status": report.orderStatus,
                }
                return newReport
            })
        }

        // Create a new workbook
        const workbook = XLSX.utils.book_new();
        const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
        // Add the sheet to the workbook
        XLSX.utils.book_append_sheet(workbook, sheetData, 'OrderRequestReport');
        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, 'Order_Request_Report.xlsx');
    };

    const customeFilterSection = (
        <div className="d-flex align-items-center justify-content-start">
            <InputGroup style={{ minWidth: '250px' }}>
                <Flatpickr
                    ref={flatpickrRef}
                    className="form-control"
                    placeholder="Start Date - End Date"
                    options={{
                        mode: 'range',
                        dateFormat: 'd-m-Y'
                    }}
                    value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
                    onChange={handleDateChange}
                />
                <Button variant="primary"
                    onClick={handleDateFilter}
                    style={{ backgroundColor: "#344fa0", border: "none" }}>
                    Go
                </Button>
            </InputGroup>
        </div>
    )

    const buttonSection = (
        <div className="text-sm-end">
            <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={downloadExcel}
            >
                <i className="bx bx-archive-in me-1" />
                {'Download'}
            </Button>

        </div>
    );

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="Reports" breadcrumbItem="Order Request Report" />
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <TableContainerV1
                                    columns={columns}
                                    data={orderReportData}
                                    pagination={pagination}
                                    handlePageChange={handlePageChange}
                                    searchHelperText={searchHelperText}
                                    handleSearchFilter={handleSearchFilter}
                                    customFilterSection={customeFilterSection}
                                    customSection={buttonSection}
                                    sortOptions={sortingOptions}
                                    handleClearSearch={handleClearSearch}
                                    handleSortColumn={handleSortColumn}
                                    className="custom-header-css"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default OrderRequestReport;
